import media from 'constants/styles/media';
import React from 'react';
import { FieldValues, Path, UseFormRegister } from 'react-hook-form';
import colors from 'src/constants/styles/colors';
import styled from 'styled-components';

interface Props<TFormValues extends FieldValues> {
    type: string;
    name: Path<TFormValues>;
    label: string;
    placeholder: string;
    register: UseFormRegister<TFormValues>;
    required?: boolean;
}

const SWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 6px;

    @media (max-width: ${media.tablet}) {
        width: 100%;
    }
`;

const SLabel = styled.label`
    font-weight: 500;
    font-size: 14px;
    line-height: 20px
    letter-spacing: 0.02em;
    color: ${colors.gray_70};
`;

const SInput = styled.input`
    width: 100%;
    height: 44px;
    background: ${colors.white};
    border: 1px solid ${colors.gray_40};
    border-radius: 8px;
    padding: 10px 14px;
    outline: none;
    font-size: 16px;
    line-height: 1;
    color: ${colors.gray_90};

    ::placeholder,
    ::-webkit-input-placeholder {
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0.01em;
        color: ${colors.gray_70};
    }
`;

export function Input<TFormValues extends FieldValues>({
    type,
    name,
    label,
    placeholder,
    register,
    required,
}: Props<TFormValues>) {
    return (
        <SWrapper>
            <SLabel htmlFor={name}>{label}</SLabel>
            <SInput type={type} placeholder={placeholder} {...register(name, { required })} />
        </SWrapper>
    );
}
